(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AA-guide-theme-1"]) return;
  try {
    
(function () {
  function runDemo(btn, result) {
    if (!window.ButtonFeedback) return;
    btn.style.minWidth = btn.offsetWidth + 'px';
    window.ButtonFeedback.loading(btn);
    setTimeout(function () {
      if (result === 'error') {
        window.ButtonFeedback.error(btn);
      } else {
        window.ButtonFeedback.success(btn);
      }
    }, 1500);
  }

  document.querySelectorAll('[data-guide-demo-success]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'success'); });
  });

  document.querySelectorAll('[data-guide-demo-error]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'error'); });
  });

  document.querySelectorAll('[data-guide-demo-custom]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'success'); });
  });

  document.querySelectorAll('[data-copy-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pre = btn.previousElementSibling;
      navigator.clipboard.writeText(pre.textContent.trim()).then(function () {
        var original = btn.textContent;
        btn.textContent = 'Copiado!';
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["AA-guide-theme-2"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-copy-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pre = btn.previousElementSibling;
      navigator.clipboard.writeText(pre.textContent.trim()).then(function () {
        var original = btn.textContent;
        btn.textContent = 'Copiado!';
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-seo-metaobject"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (document.documentElement.dataset.collectionSeoReady === 'true') return;

    document.documentElement.dataset.collectionSeoReady = 'true';

    const handleToggle = (toggle) => {
      const root = toggle.closest('[data-seo-root]');

      if (!root) return;

      const isExpanded = root.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest?.('[data-seo-toggle]');

      if (!toggle) return;

      handleToggle(toggle);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key != 'Enter' && event.key != ' ') return;

      const toggle = event.target.closest?.('[data-seo-toggle]');

      if (!toggle) return;

      event.preventDefault();
      handleToggle(toggle);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["institutional-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-institutional-page]';

    class InstitutionalPage {
      constructor(section) {
        this.section = section;
        this.mobileNav = section.querySelector('[data-institutional-nav]');
        this.boundBlockSelect = this.onBlockSelect.bind(this);
        this.mount();
      }

      mount() {
        if (this.section.dataset.institutionalReady === 'true') {
          this.scrollActiveLink();
          return;
        }

        this.section.dataset.institutionalReady = 'true';
        this.scrollActiveLink();
        document.addEventListener('shopify:block:select', this.boundBlockSelect);
      }

      scrollActiveLink() {
        if (!this.mobileNav) return;

        const activeLink = this.mobileNav.querySelector('.is-active');
        if (!activeLink) return;

        const navRect = this.mobileNav.getBoundingClientRect();
        const linkRect = activeLink.getBoundingClientRect();
        const offset = linkRect.left - navRect.left - ((navRect.width - linkRect.width) / 2);

        this.mobileNav.scrollBy({
          left: offset,
          behavior: 'smooth'
        });
      }

      onBlockSelect(event) {
        if (!this.section.contains(event.target)) return;

        const block = event.target.closest('.institutionalPage__editorBlock');
        if (!block) return;

        block.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }

    const instances = new WeakMap();

    const init = (scope) => {
      const sections = scope.matches && scope.matches(selector)
        ? [scope]
        : Array.from(scope.querySelectorAll(selector));

      sections.forEach((section) => {
        if (instances.has(section)) {
          instances.get(section).scrollActiveLink();
          return;
        }

        instances.set(section, new InstitutionalPage(section));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-hotspots"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-lookbook-section]';
    const slideSelector = '[data-lookbook-slide]';
    const tabInputSelector = '[data-lookbook-tab-input]';
    const hotspotSelector = '[data-lookbook-hotspot]';
    const buttonSelector = '[data-lookbook-hotspot-button]';
    const panelSelector = '[data-lookbook-hotspot-panel]';
    const variantSelectSelector = '[data-lookbook-variant-select]';
    const variantPickerSelector = '[data-lookbook-variant-picker]';
    const variantToggleSelector = '[data-lookbook-variant-toggle]';
    const variantOptionsSelector = '[data-lookbook-variant-options]';
    const variantOptionSelector = '[data-lookbook-variant-option]';
    const buyButtonSelector = '[data-lookbook-buy]';

    class LookbookOccasion {
      constructor(section) {
        this.section = section;
        this.boundClick = this.onClick.bind(this);
        this.boundDocumentClick = this.onDocumentClick.bind(this);
        this.boundChange = this.onChange.bind(this);
        this.boundKeydown = this.onKeydown.bind(this);
        this.boundResize = this.onResize.bind(this);
        this.boundBlockSelect = this.onBlockSelect.bind(this);
        this.boundPointerDown = this.onPointerDown.bind(this);
        this.boundPointerUp = this.onPointerUp.bind(this);
        this.boundPointerCancel = this.onPointerCancel.bind(this);
        this.boundUserInteraction = this.onUserInteraction.bind(this);
        this.tabNav = null;
        this.pointerStartX = null;
        this.pointerStartY = null;
        this.pointerId = null;

        
        this.designMode = Boolean(window.Shopify && Shopify.designMode);
this.autoplayEnabled = this.section.dataset.autoplay === 'true';
        this.autoplaySpeed = parseInt(this.section.dataset.autoplaySpeed || '5', 10) * 1000;
        this.autoplayTimer = null;

        this.mount();
      }

      mount() {
        this.createTabNav();
        this.bindVariantPickers();

        const initialInput = this.section.querySelector(tabInputSelector + ':checked');
        const initialSlide = initialInput
          ? initialInput.closest(slideSelector)
          : this.section.querySelector(slideSelector);

        if (this.section.dataset.lookbookReady === 'true') {
          if (initialSlide) this.activateSlide(initialSlide.dataset.slideId);
          this.startAutoplay();
          return;
        }

        this.section.dataset.lookbookReady = 'true';
        this.section.addEventListener('click', this.boundClick);
        this.section.addEventListener('keydown', this.boundKeydown);
        this.section.addEventListener('change', this.boundChange);
        document.addEventListener('click', this.boundDocumentClick);
        window.addEventListener('resize', this.boundResize);
        document.addEventListener('shopify:block:select', this.boundBlockSelect);
        this.section.addEventListener('pointerdown', this.boundPointerDown, { passive: true });
        this.section.addEventListener('pointerup', this.boundPointerUp, { passive: true });
        this.section.addEventListener('pointercancel', this.boundPointerCancel, { passive: true });
        this.section.addEventListener('keydown', this.boundUserInteraction);

        if (initialSlide) {
          this.activateSlide(initialSlide.dataset.slideId);
        }
        this.startAutoplay();
      }

      bindVariantPickers() {
        this.section.querySelectorAll(variantPickerSelector).forEach((picker) => {
          const toggle = picker.querySelector(variantToggleSelector);
          if (!toggle) return;

          toggle.setAttribute('aria-expanded', picker.open ? 'true' : 'false');
          if (picker.dataset.variantPickerBound === 'true') return;

          picker.dataset.variantPickerBound = 'true';
          picker.addEventListener('toggle', () => {
            toggle.setAttribute('aria-expanded', picker.open ? 'true' : 'false');
          });

          picker.querySelectorAll(variantOptionSelector).forEach((option) => {
            if (option.dataset.variantOptionBound === 'true') return;

            option.dataset.variantOptionBound = 'true';
            option.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              this.selectVariantOption(option);
            });
          });
        });
      }

      shouldAutoplay() {
                if (!this.autoplayEnabled) return false;
        const openHotspots = this.section.querySelectorAll(hotspotSelector + '[data-state="pinned"]');
        return openHotspots.length === 0;
      }

      startAutoplay() {
        if (!this.shouldAutoplay()) {
          this.stopAutoplay();
          return;
        }
        this.stopAutoplay();
        this.autoplayTimer = setInterval(() => {
          this.nextSlide();
        }, this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      stopAutoplayAfterManualInteraction() {
        this.autoplayEnabled = false;
        this.stopAutoplay();
      }

      onUserInteraction() {
        this.stopAutoplayAfterManualInteraction();
      }

      onPointerDown(event) {
        this.stopAutoplayAfterManualInteraction();

        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('a, button, input, select, details, [data-lookbook-hotspot], [data-lookbook-hotspot-panel]')) return;

        this.pointerId = event.pointerId;
        this.pointerStartX = event.clientX;
        this.pointerStartY = event.clientY;
      }

      onPointerUp(event) {
        if (this.pointerId === null || event.pointerId !== this.pointerId) return;

        const deltaX = event.clientX - this.pointerStartX;
        const deltaY = event.clientY - this.pointerStartY;

        this.pointerId = null;
        this.pointerStartX = null;
        this.pointerStartY = null;

        if (Math.abs(deltaX) < 35 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

        if (deltaX < 0) this.nextSlide();
        else this.previousSlide();
      }

      onPointerCancel(event) {
        if (this.pointerId !== null && event.pointerId === this.pointerId) {
          this.pointerId = null;
          this.pointerStartX = null;
          this.pointerStartY = null;
        }
      }

      previousSlide() {
        const slides = Array.from(this.section.querySelectorAll(slideSelector));
        if (slides.length <= 1) return;

        const currentActiveSlide = slides.find((slide) => slide.dataset.active === 'true');
        let previousIndex = slides.length - 1;
        if (currentActiveSlide) {
          const currentIndex = slides.indexOf(currentActiveSlide);
          previousIndex = (currentIndex - 1 + slides.length) % slides.length;
        }

        this.activateSlide(slides[previousIndex].dataset.slideId);
      }

      nextSlide() {
        if (!document.body.contains(this.section)) {
          this.stopAutoplay();
          return;
        }
        const slides = Array.from(this.section.querySelectorAll(slideSelector));
        if (slides.length <= 1) return;

        const currentActiveSlide = slides.find((slide) => slide.dataset.active === 'true');
        let nextIndex = 0;
        if (currentActiveSlide) {
          const currentIndex = slides.indexOf(currentActiveSlide);
          nextIndex = (currentIndex + 1) % slides.length;
        }
        const nextSlide = slides[nextIndex];
        if (nextSlide) {
          this.activateSlide(nextSlide.dataset.slideId);
        }
      }

      onClick(event) {
        const variantToggle = event.target.closest(variantToggleSelector);
        if (variantToggle && this.section.contains(variantToggle)) {
          this.closeVariantSelects(variantToggle.closest(variantPickerSelector));
          return;
        }

        const variantOption = event.target.closest(variantOptionSelector);
        if (variantOption && this.section.contains(variantOption)) {
          event.preventDefault();
          event.stopPropagation();
          this.selectVariantOption(variantOption);
          return;
        }

        this.closeVariantSelects();

        const button = event.target.closest(buttonSelector);
        if (button && this.section.contains(button)) {
          const hotspot = button.closest(hotspotSelector);
          if (!hotspot) return;

          event.preventDefault();
          event.stopPropagation();
          button.blur();

          if (hotspot.dataset.state === 'pinned') {
            this.closeHotspot(hotspot);
            return;
          }

          this.closeOthers(hotspot);
          this.openHotspot(hotspot, 'pinned');
          return;
        }

        const buyButton = event.target.closest(buyButtonSelector);
        if (buyButton && this.section.contains(buyButton)) {
          event.preventDefault();
          event.stopPropagation();
          this.handleBuy(buyButton);
        }
      }

      onDocumentClick(event) {
        if (event.target.closest(variantPickerSelector)) return;
        this.closeVariantSelects();
        if (event.target.closest(panelSelector) || event.target.closest(buttonSelector)) return;
        this.closeAll();
      }

      openVariantOptions(toggle) {
        const picker = toggle.closest(variantPickerSelector);
        const optionsList = picker?.querySelector(variantOptionsSelector);
        if (!picker || !optionsList) return;

        this.closeVariantSelects(picker);
        picker.open = true;
        toggle.setAttribute('aria-expanded', 'true');

        const selectedOption = optionsList.querySelector(`${variantOptionSelector}[aria-selected="true"]:not(:disabled)`);
        const firstAvailableOption = optionsList.querySelector(`${variantOptionSelector}:not(:disabled)`);
        (selectedOption || firstAvailableOption)?.focus();
      }

      closeVariantSelects(exceptPicker = null, scope = this.section) {
        scope.querySelectorAll(variantPickerSelector).forEach((picker) => {
          if (picker === exceptPicker) return;

          const toggle = picker.querySelector(variantToggleSelector);
          picker.open = false;
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      }

      selectVariantOption(option) {
        const picker = option.closest(variantPickerSelector);
        const optionsList = picker?.querySelector(variantOptionsSelector);
        const toggle = picker?.querySelector(variantToggleSelector);
        const select = picker?.querySelector(variantSelectSelector);
        const valueLabel = picker?.querySelector('[data-lookbook-variant-value]');
        if (!picker || !optionsList || !toggle || !select) return;

        const variantId = option.dataset.variantId || '';
        if (!variantId) return;

        select.value = variantId;
        optionsList.querySelectorAll(variantOptionSelector).forEach((variantOption) => {
          variantOption.setAttribute('aria-selected', variantOption === option ? 'true' : 'false');
        });
        if (valueLabel) valueLabel.textContent = option.textContent.trim();

        picker.open = false;
        toggle.setAttribute('aria-expanded', 'false');
        select.dispatchEvent(new Event('change', { bubbles: true }));
        toggle.focus();
      }

      onKeydown(event) {
        const toggle = event.target.closest(variantToggleSelector);
        if (toggle && this.section.contains(toggle)) {
          if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
            event.preventDefault();
            this.closeVariantSelects();
            toggle.focus();
            return;
          }

          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            if (toggle.getAttribute('aria-expanded') !== 'true') this.openVariantOptions(toggle);
          }
          return;
        }

        const option = event.target.closest(variantOptionSelector);
        if (!option || !this.section.contains(option)) return;

        const picker = option.closest(variantPickerSelector);
        const optionsList = picker?.querySelector(variantOptionsSelector);
        const toggleButton = picker?.querySelector(variantToggleSelector);
        if (!picker || !optionsList || !toggleButton) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeVariantSelects();
          toggleButton.focus();
          return;
        }

        if (event.key === 'Tab') {
          event.preventDefault();
          this.closeVariantSelects();
          const nextControl = event.shiftKey
            ? toggleButton
            : picker.closest('[data-lookbook-product-card]')?.querySelector(buyButtonSelector);
          nextControl?.focus();
          return;
        }

        const availableOptions = Array.from(optionsList.querySelectorAll(`${variantOptionSelector}:not(:disabled)`));
        const currentIndex = availableOptions.indexOf(option);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowDown') nextIndex = Math.min(currentIndex + 1, availableOptions.length - 1);
        else if (event.key === 'ArrowUp') nextIndex = Math.max(currentIndex - 1, 0);
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = availableOptions.length - 1;
        else return;

        event.preventDefault();
        availableOptions[nextIndex]?.focus();
      }

      onChange(event) {
        const tabInput = event.target.closest(tabInputSelector);
        if (tabInput && this.section.contains(tabInput)) {
          this.activateSlide(tabInput.value);
          return;
        }

        const variantSelect = event.target.closest(variantSelectSelector);
        if (!variantSelect || !this.section.contains(variantSelect)) return;

        const panelCard = variantSelect.closest('[data-lookbook-product-card]');
        if (!panelCard) return;

        this.syncProductCard(panelCard);
      }

      onResize() {
        this.section.querySelectorAll(hotspotSelector + '[data-state="preview"], ' + hotspotSelector + '[data-state="pinned"]').forEach((hotspot) => {
          this.positionPanel(hotspot);
        });
      }

      onBlockSelect(event) {
        const slide = event.target.closest(slideSelector);
        if (slide && this.section.contains(slide)) {
          this.activateSlide(slide.dataset.slideId);
          return;
        }

        const hotspot = event.target.closest(hotspotSelector);
        if (hotspot && this.section.contains(hotspot)) {
          const parentSlide = hotspot.closest(slideSelector);
          if (parentSlide) {
            this.activateSlide(parentSlide.dataset.slideId);
          }
          this.closeOthers(hotspot);
          this.openHotspot(hotspot, 'pinned');
        }
      }

      createTabNav() {
        const slides = Array.from(this.section.querySelectorAll(slideSelector));
        if (!slides.length) return;

        const tabNav = document.createElement('div');
        tabNav.className = 'lookbookSlide__tabNav';
        tabNav.setAttribute('aria-hidden', 'true');

        slides.forEach((slide, index) => {
          const indicator = document.createElement('span');
          indicator.className = 'lookbookSlide__indicator';
          indicator.dataset.slideIndicator = slide.dataset.slideId || String(index);
          tabNav.appendChild(indicator);
        });

        this.tabNav = tabNav;
      }

      moveTabNav(slide) {
        if (!this.tabNav || !slide) return;
        const content = slide.querySelector('.lookbookSlide__content');
        if (content) content.appendChild(this.tabNav);
      }

      activateSlide(slideId) {
        const slides = Array.from(this.section.querySelectorAll(slideSelector));
        if (!slides.length) return;

        slides.forEach((slide) => {
          const isActive = slide.dataset.slideId === slideId;
          slide.dataset.active = isActive ? 'true' : 'false';
          const tabInput = slide.querySelector(tabInputSelector);
          if (tabInput) {
            tabInput.checked = isActive;
            const tab = this.tabNav
              ? this.tabNav.querySelector('label[for="' + tabInput.id + '"]')
              : slide.querySelector('.lookbookOccasion__tab');
            if (tab) tab.classList.toggle('is-active', isActive);
          }
          if (!isActive) {
            slide.querySelectorAll(hotspotSelector).forEach((hotspot) => this.closeHotspot(hotspot));
          }
        });

        const activeSlide = slides.find((slide) => slide.dataset.slideId === slideId);
        if (activeSlide) this.moveTabNav(activeSlide);

        if (this.autoplayEnabled) {
          this.startAutoplay();
        }
      }

      syncProductCard(panelCard) {
        const select = panelCard.querySelector(variantSelectSelector);
        const buyButton = panelCard.querySelector(buyButtonSelector);
        if (!buyButton) return;

        if (!select) {
          buyButton.disabled = buyButton.dataset.available !== 'true';
          return;
        }

        const selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) {
          buyButton.disabled = true;
          buyButton.dataset.variantId = '';
          return;
        }

        const variantId = selectedOption.value || '';
        const isAvailable = !selectedOption.disabled;

        buyButton.dataset.variantId = variantId;
        buyButton.disabled = !(variantId && isAvailable);
      }

      async handleBuy(button) {
        const productCard = button.closest('[data-lookbook-product-card]');
        const select = productCard ? productCard.querySelector(variantSelectSelector) : null;
        const selectedOption = select ? select.options[select.selectedIndex] : null;
        const variantId = selectedOption ? selectedOption.value || '' : button.dataset.variantId || '';

        if (selectedOption) {
          button.dataset.variantId = variantId;
          button.disabled = !(variantId && !selectedOption.disabled);
        }

        if (!variantId || button.disabled) return;
        if (!window.CartManager || typeof window.CartManager.add !== 'function') return;

        const variantPrice = selectedOption?.dataset.price;
        if (variantPrice === undefined || Number(variantPrice) <= 0) return;

        await window.CartManager.add(variantId, {
          button,
          action: 'open_drawer',
          variantPrice,
        });
      }

      openHotspot(hotspot, state) {
        const panel = hotspot.querySelector(panelSelector);
        const button = hotspot.querySelector(buttonSelector);
        if (!panel || !button) return;

        hotspot.dataset.state = state;
        button.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');

        const panelCard = panel.querySelector('[data-lookbook-product-card]');
        if (panelCard) {
          this.syncProductCard(panelCard);
        }

        window.requestAnimationFrame(() => this.positionPanel(hotspot));

        this.stopAutoplay();
      }

      closeHotspot(hotspot) {
        const panel = hotspot.querySelector(panelSelector);
        const button = hotspot.querySelector(buttonSelector);
        if (!panel || !button) return;

        this.closeVariantSelects(null, hotspot);
        hotspot.dataset.state = 'closed';
        hotspot.dataset.placement = '';
        button.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');

        this.startAutoplay();
      }

      closeOthers(exceptHotspot) {
        this.section.querySelectorAll(hotspotSelector).forEach((hotspot) => {
          if (hotspot === exceptHotspot) return;
          this.closeHotspot(hotspot);
        });
      }

      closeAll() {
        this.section.querySelectorAll(hotspotSelector).forEach((hotspot) => this.closeHotspot(hotspot));
      }

      positionPanel(hotspot) {
        const panel = hotspot.querySelector(panelSelector);
        if (!panel || hotspot.dataset.state === 'closed') return;

        panel.style.setProperty('--lookbook-panel-shift-x', '0px');
        panel.style.setProperty('--lookbook-panel-shift-y', '0px');
        hotspot.dataset.placement = 'right';

        const hotspotRect = hotspot.getBoundingClientRect();
        const viewportPadding = 16;
        const gap = window.innerWidth < 990 ? 8 : 12;
        const isMobile = window.innerWidth < 990;
        const bounds = {
          left: viewportPadding,
          right: window.innerWidth - viewportPadding,
          top: viewportPadding,
          bottom: window.innerHeight - viewportPadding
        };
        const spaceRight = bounds.right - hotspotRect.right;
        const spaceLeft = hotspotRect.left - bounds.left;
        const spaceBottom = bounds.bottom - hotspotRect.bottom;
        const spaceTop = hotspotRect.top - bounds.top;

        let placements = ['right', 'left', 'bottom', 'top'];
        if (isMobile) {
          placements = ['bottom', 'top', 'right', 'left'];
        }

        let chosenPlacement = placements[0];
        const panelWidth = Math.min(320, window.innerWidth - (viewportPadding * 2));
        const measurePanelHeight = () => panel.getBoundingClientRect().height;

        placements.some((placement) => {
          const panelHeight = measurePanelHeight();

          if (placement === 'right' && spaceRight >= panelWidth + gap) {
            chosenPlacement = placement;
            return true;
          }

          if (placement === 'left' && spaceLeft >= panelWidth + gap) {
            chosenPlacement = placement;
            return true;
          }

          if (placement === 'bottom' && spaceBottom >= panelHeight + gap) {
            chosenPlacement = placement;
            return true;
          }

          if (placement === 'top' && spaceTop >= panelHeight + gap) {
            chosenPlacement = placement;
            return true;
          }

          return false;
        });

        hotspot.dataset.placement = chosenPlacement;
        const panelRect = panel.getBoundingClientRect();
        let shiftX = 0;
        let shiftY = 0;

        if (panelRect.left < bounds.left) {
          shiftX += bounds.left - panelRect.left;
        } else if (panelRect.right > bounds.right) {
          shiftX -= panelRect.right - bounds.right;
        }

        if (panelRect.top < bounds.top) {
          shiftY += bounds.top - panelRect.top;
        } else if (panelRect.bottom > bounds.bottom) {
          shiftY -= panelRect.bottom - bounds.bottom;
        }

        if (isMobile && chosenPlacement !== 'left' && chosenPlacement !== 'right') {
          shiftY = 0;
        }

        panel.style.setProperty('--lookbook-panel-shift-x', Math.round(shiftX) + 'px');
        panel.style.setProperty('--lookbook-panel-shift-y', Math.round(shiftY) + 'px');
      }
    }

    const init = (scope = document) => {
      const sections = [];

      if (scope && typeof scope.matches === 'function' && scope.matches(sectionSelector)) {
        sections.push(scope);
      } else if (scope && typeof scope.querySelectorAll === 'function') {
        sections.push(...Array.from(scope.querySelectorAll(sectionSelector)));
      }

      sections.forEach((section) => new LookbookOccasion(section));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
